import {Unit} from '@cypro/engine/schema'

export function mapUnitsToSelectItems(units: Unit[]) {
  return units.map(u => {
    return {...u, label: u.ucumCode, value: u.id}
  })
}
